var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYandex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 12.6177 0 7.92655 2.47976 4.69486C3.11817 3.86288 3.86288 3.11817 4.69486 2.47976C7.92655 0 12.6177 0 22 0C31.3823 0 36.0735 0 39.3051 2.47976C40.1371 3.11817 40.8818 3.86288 41.5202 4.69486C44 7.92655 44 12.6177 44 22C44 31.3823 44 36.0735 41.5202 39.3051C40.8818 40.1371 40.1371 40.8818 39.3051 41.5202C36.0735 44 31.3823 44 22 44C12.6177 44 7.92655 44 4.69486 41.5202C3.86288 40.8818 3.11817 40.1371 2.47976 39.3051C0 36.0735 0 31.3823 0 22Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FC3F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6911 29.212H26.1981V14.812H22.5515C18.8841 14.812 16.9572 16.6975 16.9572 19.4739C16.9572 21.6909 18.0139 22.9962 19.8994 24.3429L16.6257 29.212H19.34L22.9866 23.7628L21.7227 22.9133C20.1895 21.8773 19.4436 21.0693 19.4436 19.3288C19.4436 17.7956 20.521 16.7596 22.5722 16.7596H23.6911V29.212Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.2fef29aa58437b051536e013dd0cb79f.svg";
export { ForwardRef as ReactComponent };